import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Documents from "../DocumentsF/Documents";
import LeaseAgreement from "../Lease AgreementF/LeaseAgreement";
import ResidenceInfomation from "../Residence Infomation/ResidenceInfomation";
import Toast from "./Toast";
import { DocumentContext } from "../DocumentsF/DocumentContext";
import Invoice from "../invoice/Invoice";
import MissingDocumentsModal from "../DocumentsF/MissingDocumentsModal";
import Maintenance from "../Student/Maintenance";
import { REQUIRED_DOCUMENTS } from "../DocumentsF/documentRequirements";
import MSAAssistant from "./MSAAssistant";
import {
  User,
  FileSignature,
  CreditCard,
  Home,
  BedDouble,
  FileText,
  GraduationCap,
  Bell,
  X,
  Camera,
  LogOut,
  ChevronLeft,
  ChevronRight,
  LayoutDashboard,
  CheckCircle,
  AlertCircle,
  Menu,
  Sparkles,
  Calendar,
  Mail,
  Phone,
  MapPin,
  Award,
  Users,
  Wrench,
} from "lucide-react";

const Dashboard = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("overview");
  const [currentStep, setCurrentStep] = useState(0);
  const [toast, setToast] = useState({ message: "", type: "" });
  const { uploadedCount, setUploadedCount, documentsState, setDocumentsState } = useContext(DocumentContext);
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  const [residenceId, setResidenceId] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const [showMissingDocsModal, setShowMissingDocsModal] = useState(false);
  const [missingDocs, setMissingDocs] = useState([]);


  // Announcement states
  const [announcements, setAnnouncements] = useState([]);
  const [showNotifications, setShowNotifications] = useState(false);
  const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);
  const [showAnnouncementModal, setShowAnnouncementModal] = useState(false);
  
  // Read announcements state
  const [readAnnouncements, setReadAnnouncements] = useState([]);

  // Notification Bell State
  const [notifications, setNotifications] = useState([]);
  
  const [hasNew, setHasNew] = useState(false);

  // Room info state
  const [roomInfo, setRoomInfo] = useState({
    roomNumber: null,
    block: null,
    floor: null,
    capacity: null,
    occupied: null,
  });

  // State for Personal Info
  const [personalInfo, setPersonalInfo] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    gender: "",
    studentIdNumber: "",
    email: "",
    studentPhoneNumber: "",
    studentNumber: "",
    studentMedicalCondition: "",
    studentAddress: "",
  });

  // State for University Info
  const [universityInfo, setUniversityInfo] = useState({
    studentCourse: "",
    studentStudyYear: "",
    residenceName: "",
    universityName: "",
    paymentMethod: "",
  });

  // State for Next of Kin
  const [nextOfKin, setNextOfKin] = useState({
    kinFirstName: "",
    kinLastName: "",
    kinRelationShip: "",
    kinPhone: "",
    kinEmail: "",
    kinAddress: "",
    kinIdNumber: "",
  });

  // Load read announcements from sessionStorage on component mount
  useEffect(() => {
    const studentId = sessionStorage.getItem("StudentUserId");
    if (studentId) {
      const storedRead = sessionStorage.getItem(`readAnnouncements_${studentId}`);
      if (storedRead) {
        setReadAnnouncements(JSON.parse(storedRead));
      }
    }
  }, []);
  // Fetch document counts immediately on load, so the Overview tab
// shows the correct number without requiring a visit to Documents tab
useEffect(() => {
  const fetchDocumentCounts = async () => {
    const studentId = sessionStorage.getItem("StudentUserId");
    if (!studentId) return;

    try {
      const res = await axios.get(
        `https://msarestapis-acckcpbyeshpa3f3.southafricanorth-01.azurewebsites.net/api/StudentDocuments/${studentId}`
      );

      const updatedDocs = {
        idOrPassport: { file: null, documentId: null, status: "Not Uploaded", fileName: null },
        proofOfFunding: { file: null, documentId: null, status: "Not Uploaded", fileName: null },
        nextOfKinID: { file: null, documentId: null, status: "Not Uploaded", fileName: null },
        proofOfResidence: { file: null, documentId: null, status: "Not Uploaded", fileName: null },
      };

      res.data.forEach((doc) => {
        if (updatedDocs[doc.documentType]) {
          updatedDocs[doc.documentType] = {
            ...updatedDocs[doc.documentType],
            documentId: doc.documentId,
            status: doc.status === "Approved" ? "Approved" : (doc.status || "Uploaded"),
            fileName: doc.filePath?.split("\\").pop().split("/").pop() || null,
          };
        }
      });

      const count = Object.values(updatedDocs).filter((d) => d.documentId).length;
      setUploadedCount(count);
      setDocumentsState(updatedDocs);
    } catch (err) {
      console.error("Error fetching document counts:", err);
    }
  };

  fetchDocumentCounts();
}, []);

  useEffect(() => {
    const checkMissingDocs = async () => {
      const studentId = sessionStorage.getItem("StudentUserId");
      if (!studentId) return;

      try {
        const res = await axios.get(
          `https://msarestapis-acckcpbyeshpa3f3.southafricanorth-01.azurewebsites.net/api/StudentDocuments/${studentId}`
        );
        const docs = {};
        res.data.forEach((doc) => {
          docs[doc.documentType] = {
            documentId: doc.documentId,
            status: doc.status || "Uploaded",
            fileName: doc.filePath?.split("\\").pop().split("/").pop() || null,
          };
        });

        const missing = Object.keys(REQUIRED_DOCUMENTS).filter(
          (key) => !docs[key]?.documentId
        );

        if (missing.length > 0) {
          setMissingDocs(missing);
          setShowMissingDocsModal(true);
        } else {
          setShowMissingDocsModal(false);
        }
      } catch (err) {
        console.error("Error checking documents:", err);
      }
    };

    checkMissingDocs();
  }, [documentsState]);

  const validateStep = () => {
    if (currentStep === 0) {
      const {
        firstName,
        lastName,
        email,
        studentPhoneNumber,
        studentIdNumber,
        studentNumber,
      } = personalInfo;

      if (
        !firstName ||
        !lastName ||
        !studentIdNumber ||
        !studentNumber ||
        !studentPhoneNumber ||
        !email
      ) {
        setToast({ message: "Please fill in all required fields (*).", type: "error" });
        return false;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        setToast({ message: "Invalid email format.", type: "error" });
        return false;
      }

      const phoneRegex = /^\+?\d{7,15}$/;
      if (!phoneRegex.test(studentPhoneNumber)) {
        setToast({ message: "Invalid phone number format.", type: "error" });
        return false;
      }
    }

    if (currentStep === 1) {
      const { studentCourse, studentStudyYear } = universityInfo;
      if (!studentCourse || !studentStudyYear) {
        setToast({ message: "Course and Study Year are required.", type: "error" });
        return false;
      }
    }

    if (currentStep === 2) {
      const { kinFirstName, kinLastName, kinPhone } = nextOfKin;
      if (!kinFirstName || !kinLastName || !kinPhone) {
        setToast({ message: "Next of Kin name and phone number are required.", type: "error" });
        return false;
      }
    }

    return true;
  };

  const [profilePicture, setProfilePicture] = useState(null);

  // Fetch personal info, university info, etc.
  useEffect(() => {
    const studentId = sessionStorage.getItem("StudentUserId");
    if (!studentId) return;

    if (activeTab === "overview" || activeTab === "profile") {
      axios
        .get(`https://msarestapis-acckcpbyeshpa3f3.southafricanorth-01.azurewebsites.net/api/RoomStatus/${studentId}`)
        .then((res) => {
          const data = res.data;
          if (data.isAssigned === 1 && data.room) {
            const r = data.room;
            setRoomInfo({
              roomNumber: r.roomNumber,
              block: r.building,
              floor: r.floor,
              capacity: r.capacity,
              occupied: r.occupied,
            });
          } else {
            setRoomInfo({
              roomNumber: null,
              block: null,
              floor: null,
              capacity: null,
              occupied: null,
            });
          }
        })
        .catch((err) => console.error("Room info fetch error:", err));

      axios
        .get(`https://msarestapis-acckcpbyeshpa3f3.southafricanorth-01.azurewebsites.net/api/UserInformation/personal/${studentId}`)
        .then((res) => {
          setPersonalInfo({
            firstName: res.data.firstName || "",
            middleName: res.data.middleName || "",
            lastName: res.data.lastName || "",
            gender: res.data.gender || "",
            studentIdNumber: res.data.idNumber || "",
            email: res.data.email || "",
            studentPhoneNumber: res.data.phone || "",
            studentNumber: res.data.studentNumber || "",
            studentMedicalCondition: res.data.medicalConditions || "",
            studentAddress: "",
          });

          if (res.data.profilePictureUrl) {
            const fullUrl = `https://msarestapis-acckcpbyeshpa3f3.southafricanorth-01.azurewebsites.net/${res.data.profilePictureUrl}`;
            setProfilePicture(fullUrl);
          }
        })
        .catch((err) => console.error("Personal info fetch error:", err));

      axios
        .get(`https://msarestapis-acckcpbyeshpa3f3.southafricanorth-01.azurewebsites.net/api/UserInformation/university/${studentId}`)
        .then((res) => {
          setUniversityInfo({
            studentCourse: res.data.fieldOfStudy || "",
            studentStudyYear: res.data.yearOfStudy || "",
            residenceName: res.data.residenceName || "",
            universityName: res.data.universityName || "",
            paymentMethod: res.data.paymentMethod || "",
          });
          setResidenceId(res.data.residenceId || null);
        })
        .catch((err) => console.error("University info fetch error:", err));

      axios
        .get(`https://msarestapis-acckcpbyeshpa3f3.southafricanorth-01.azurewebsites.net/api/UserInformation/nextofkin/${studentId}`)
        .then((res) =>
          setNextOfKin({
            kinFirstName: res.data.nextOfKinName || "",
            kinLastName: res.data.nextOfKinLastName || "",
            kinRelationShip: res.data.relationship || "",
            kinPhone: res.data.nextOfKinPhone || "",
            kinEmail: res.data.nextOfKinEmail || "",
            kinAddress: res.data.nextOfKinHomeAddress || "",
            kinIdNumber: res.data.nextOfKinIdNumber || "",
          })
        )
        .catch((err) => console.error("Next of Kin fetch error:", err));

      axios
        .get(`https://msarestapis-acckcpbyeshpa3f3.southafricanorth-01.azurewebsites.net/api/UserInformation/address/${studentId}`)
        .then((res) =>
          setPersonalInfo((prev) => ({
            ...prev,
            studentAddress: res.data.streetAddress || "",
          }))
        )
        .catch((err) => console.error("Address fetch error:", err));
    }
  }, [activeTab]);

  // Fetch announcements for the student - depends on gender and residenceId
  useEffect(() => {
    const fetchAnnouncements = async () => {
      const studentId = sessionStorage.getItem("StudentUserId");
      if (!studentId) {
        console.log("No student ID found");
        return;
      }

      // Wait for residenceId to be loaded
      if (!residenceId) {
        console.log("Waiting for residence ID...");
        return;
      }

      console.log("Fetching announcements for student:", studentId);
      console.log("Residence ID:", residenceId);
      console.log("Student gender:", personalInfo.gender);

      try {
        const response = await axios.get(
          `https://msarestapis-acckcpbyeshpa3f3.southafricanorth-01.azurewebsites.net/api/Announcements/student/${studentId}`
        );
        console.log("Announcements received:", response.data);
        setAnnouncements(response.data);

        // Only add to notifications if there are announcements
        if (response.data.length > 0) {
          // Clear existing announcement notifications to avoid duplicates
          setNotifications(prev => prev.filter(n => !n.isAnnouncement));

          // Add all announcements as notifications
          response.data.forEach(announcement => {
            // Check if announcement has been read
            const isRead = readAnnouncements.includes(announcement.id);
            
            setNotifications(prev => {
              // Check if announcement already exists in notifications
              const exists = prev.some(n => n.isAnnouncement && n.id === announcement.id);
              if (!exists) {
                return [
                  {
                    id: announcement.id,
                    message: `📢 ${announcement.title}`,
                    time: new Date(announcement.createdAt).toLocaleString(),
                    type: "announcement",
                    isAnnouncement: true,
                    isRead: isRead,
                    announcementData: announcement
                  },
                  ...prev
                ];
              }
              return prev;
            });
          });
          
          // Only set hasNew to true if there are unread announcements
          const hasUnread = response.data.some(announcement => !readAnnouncements.includes(announcement.id));
          setHasNew(hasUnread);
        } else {
          console.log("No announcements to display");
        }
      } catch (err) {
        console.error("Error fetching announcements:", err);
      }
    };

    fetchAnnouncements();
  }, [residenceId, personalInfo.gender, readAnnouncements]);

  // Handle notification click
  const handleNotificationClick = (notification) => {
    if (notification.isAnnouncement && notification.announcementData) {
      // Mark this announcement as read if not already read
      if (!readAnnouncements.includes(notification.id)) {
        const updatedRead = [...readAnnouncements, notification.id];
        setReadAnnouncements(updatedRead);
        
        // Save to sessionStorage
        const studentId = sessionStorage.getItem("StudentUserId");
        if (studentId) {
          sessionStorage.setItem(`readAnnouncements_${studentId}`, JSON.stringify(updatedRead));
        }
        
        // Update notification to marked as read
        setNotifications(prev => 
          prev.map(n => 
            n.id === notification.id ? { ...n, isRead: true } : n
          )
        );
        
        // Check if there are still any unread announcements
        const stillHasUnread = notifications.some(n => 
          n.isAnnouncement && !n.isRead && n.id !== notification.id
        );
        setHasNew(stillHasUnread);
      }
      
      setSelectedAnnouncement(notification.announcementData);
      setShowAnnouncementModal(true);
    }
  };

  // Mark all announcements as read
  const markAllAsRead = () => {
    const studentId = sessionStorage.getItem("StudentUserId");
    const unreadIds = notifications
      .filter(n => n.isAnnouncement && !n.isRead)
      .map(n => n.id);
    
    if (unreadIds.length === 0) return;
    
    const updatedRead = [...readAnnouncements, ...unreadIds];
    setReadAnnouncements(updatedRead);
    
    if (studentId) {
      sessionStorage.setItem(`readAnnouncements_${studentId}`, JSON.stringify(updatedRead));
    }
    
    setNotifications(prev => 
      prev.map(n => 
        n.isAnnouncement && !n.isRead ? { ...n, isRead: true } : n
      )
    );
    setHasNew(false);
  };

  const handleChange = (e, setState) => {
    const { name, value } = e.target;
    setState((prev) => ({ ...prev, [name]: value }));
  };

  const nextStep = () => setCurrentStep((prev) => Math.min(prev + 1, 2));
  const prevStep = () => setCurrentStep((prev) => Math.max(prev - 1, 0));

  const handleSaveStep = async () => {
    if (!validateStep()) return;
    setIsSaving(true);
    const studentId = sessionStorage.getItem("StudentUserId");
    if (!studentId) return alert("Student ID missing");

    if (currentStep === 0) {
      const payload = {
        UserId: Number(studentId),
        FirstName: personalInfo.firstName,
        MiddleName: personalInfo.middleName,
        LastName: personalInfo.lastName,
        gender: personalInfo.gender,
        IdNumber: personalInfo.studentIdNumber,
        Email: personalInfo.email,
        Phone: personalInfo.studentPhoneNumber,
        StudentNumber: personalInfo.studentNumber,
        MedicalConditions: personalInfo.studentMedicalCondition,
        studentAddress: personalInfo.studentAddress,
      };

      axios
        .put(
          `https://msarestapis-acckcpbyeshpa3f3.southafricanorth-01.azurewebsites.net/api/UserInformation/update/personal/${studentId}`,
          payload
        )
        .then(() =>
          setToast({ message: "Personal details saved successfully!", type: "success" })
        )
        .catch((err) => {
          console.error("Update error:", err);
          setToast({ message: "Failed to save personal details", type: "error" });
        });
    } else if (currentStep === 1) {
      axios
        .put(
          `https://msarestapis-acckcpbyeshpa3f3.southafricanorth-01.azurewebsites.net/api/UserInformation/update/university/${studentId}`,
          {
            FieldOfStudy: universityInfo.studentCourse,
            YearOfStudy: universityInfo.studentStudyYear,
          }
        )
        .then(() =>
          setToast({ message: "University details saved successfully!", type: "success" })
        )
        .catch((err) => {
          console.error("Update error:", err);
          setToast({ message: "Failed to save university details", type: "error" });
        });
    } else if (currentStep === 2) {
      axios
        .put(
          `https://msarestapis-acckcpbyeshpa3f3.southafricanorth-01.azurewebsites.net/api/UserInformation/update/nextofkin/${studentId}`,
          {
            NextOfKinName: nextOfKin.kinFirstName,
            NextOfKinLastName: nextOfKin.kinLastName,
            Relationship: nextOfKin.kinRelationShip,
            NextOfKinPhone: nextOfKin.kinPhone,
            NextOfKinEmail: nextOfKin.kinEmail,
            NextOfKinIdNumber: nextOfKin.kinIdNumber,
            NextOfKinHomeAddress: nextOfKin.kinAddress,
          }
        )
        .then(() =>
          setToast({ message: "Next of kin details saved successfully!", type: "success" })
        )
        .catch((err) => {
          console.error("Update error:", err);
          setToast({ message: "Failed to save next of kin details", type: "error" });
        });
    }
    setIsSaving(false);
    setIsEditing(false);
  };

  const handleProfilePictureChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const studentId = sessionStorage.getItem("StudentUserId");
    if (!studentId) return alert("Student ID missing");

    const formData = new FormData();
    formData.append("file", file);

    axios
      .post(
        `https://msarestapis-acckcpbyeshpa3f3.southafricanorth-01.azurewebsites.net/api/UserInformation/upload/profilepicture/${studentId}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      )
      .then((res) => {
        const fullUrl = `https://msarestapis-acckcpbyeshpa3f3.southafricanorth-01.azurewebsites.net/${res.data.profilePictureUrl}`;
        setProfilePicture(fullUrl);
        setToast({ message: "Profile picture uploaded successfully!", type: "success" });
      })
      .catch((err) => console.error("Profile picture upload error:", err));
  };
const handleLogout = () => {
  sessionStorage.clear();
  navigate("/login");
};

  useEffect(() => {
    if (uploadedCount > 0) {
      setNotifications((prev) => [
        {
          id: Date.now(),
          message: `You uploaded ${uploadedCount} document${uploadedCount > 1 ? "s" : ""}.`,
          time: new Date().toLocaleTimeString(),
          type: "info",
        },
        ...prev,
      ]);
      setHasNew(true);
    }
  }, [uploadedCount]);

  useEffect(() => {
    const interval = setInterval(() => {
      const studentId = sessionStorage.getItem("StudentUserId");
      if (!studentId) return;

      axios
        .get(`https://msarestapis-acckcpbyeshpa3f3.southafricanorth-01.azurewebsites.net/api/Documents/approved/${studentId}`)
        .then((res) => {
          if (res.data && res.data.length > 0) {
            setNotifications((prev) => [
              {
                id: Date.now(),
                message: `${res.data.length} of your documents have been approved!`,
                time: new Date().toLocaleTimeString(),
                type: "success",
              },
              ...prev,
            ]);
            setHasNew(true);
          }
        })
        .catch((err) => console.error("Approval check error:", err));
    }, 20000);

    return () => clearInterval(interval);
  }, []);

  const renderProfileForm = () => {
    const inputClass = `
      w-full px-4 py-3
      border border-gray-300
      rounded-xl
      bg-white
      text-gray-800
      focus:ring-2 focus:ring-blue-500/30
      focus:border-blue-500
      transition-all duration-200
      disabled:bg-gray-100 disabled:text-gray-500
      placeholder:text-gray-400
    `;

    if (currentStep === 0) {
      return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <div className="space-y-1.5">
            <label className="text-sm font-semibold text-gray-700">First Name <span className="text-blue-600">*</span></label>
            <input
              name="firstName"
              value={personalInfo.firstName}
              onChange={(e) => handleChange(e, setPersonalInfo)}
              className={inputClass}
              disabled={!isEditing}
              placeholder="Enter first name"
            />
          </div>
          <div className="space-y-1.5">
            <label className="text-sm font-semibold text-gray-700">Middle Name</label>
            <input
              name="middleName"
              value={personalInfo.middleName}
              onChange={(e) => handleChange(e, setPersonalInfo)}
              className={inputClass}
              disabled={!isEditing}
              placeholder="Enter middle name"
            />
          </div>
          <div className="space-y-1.5">
            <label className="text-sm font-semibold text-gray-700">Last Name <span className="text-blue-600">*</span></label>
            <input
              name="lastName"
              value={personalInfo.lastName}
              onChange={(e) => handleChange(e, setPersonalInfo)}
              className={inputClass}
              disabled={!isEditing}
              placeholder="Enter last name"
            />
          </div>
          <div className="space-y-1.5">
            <label className="text-sm font-semibold text-gray-700">Gender</label>
            <select
              name="gender"
              value={personalInfo.gender}
              onChange={(e) => handleChange(e, setPersonalInfo)}
              className={inputClass}
              disabled={!isEditing}
            >
              <option value="">Select Gender</option>
              <option value="Female">Female</option>
              <option value="Male">Male</option>
              <option value="Other">Other</option>
            </select>
          </div>
          <div className="space-y-1.5">
            <label className="text-sm font-semibold text-gray-700">ID Number <span className="text-blue-600">*</span></label>
            <input
              name="studentIdNumber"
              value={personalInfo.studentIdNumber}
              onChange={(e) => handleChange(e, setPersonalInfo)}
              className={inputClass}
              disabled={!isEditing}
              placeholder="Enter ID number"
            />
          </div>
          <div className="space-y-1.5">
            <label className="text-sm font-semibold text-gray-700">Student Number <span className="text-blue-600">*</span></label>
            <input
              name="studentNumber"
              value={personalInfo.studentNumber}
              onChange={(e) => handleChange(e, setPersonalInfo)}
              className={inputClass}
              disabled={!isEditing}
              placeholder="Enter student number"
            />
          </div>
          <div className="space-y-1.5">
            <label className="text-sm font-semibold text-gray-700">Email <span className="text-blue-600">*</span></label>
            <input
              name="email"
              type="email"
              value={personalInfo.email}
              onChange={(e) => handleChange(e, setPersonalInfo)}
              className={inputClass}
              disabled={!isEditing}
              placeholder="Enter email address"
            />
          </div>
          <div className="space-y-1.5">
            <label className="text-sm font-semibold text-gray-700">Phone Number <span className="text-blue-600">*</span></label>
            <input
              name="studentPhoneNumber"
              value={personalInfo.studentPhoneNumber}
              onChange={(e) => handleChange(e, setPersonalInfo)}
              className={inputClass}
              disabled={!isEditing}
              placeholder="Enter phone number"
            />
          </div>
          <div className="space-y-1.5 md:col-span-2">
            <label className="text-sm font-semibold text-gray-700">Address</label>
            <textarea
              name="studentAddress"
              value={personalInfo.studentAddress}
              onChange={(e) => handleChange(e, setPersonalInfo)}
              className={inputClass}
              rows={2}
              disabled={!isEditing}
              placeholder="Enter your address"
            />
          </div>
          <div className="space-y-1.5 md:col-span-2">
            <label className="text-sm font-semibold text-gray-700">Medical Conditions</label>
            <textarea
              name="studentMedicalCondition"
              value={personalInfo.studentMedicalCondition}
              onChange={(e) => handleChange(e, setPersonalInfo)}
              className={inputClass}
              rows={2}
              disabled={!isEditing}
              placeholder="Any medical conditions we should know about?"
            />
          </div>
        </div>
      );
    }
    if (currentStep === 1) {
      return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <div className="space-y-1.5 md:col-span-2">
            <label className="text-sm font-semibold text-gray-700">University Name</label>
            <input
              name="universityName"
              value={universityInfo.universityName}
              className={inputClass}
              disabled
            />
          </div>
          <div className="space-y-1.5">
            <label className="text-sm font-semibold text-gray-700">Course <span className="text-blue-600">*</span></label>
            <input
              name="studentCourse"
              value={universityInfo.studentCourse}
              onChange={(e) => handleChange(e, setUniversityInfo)}
              className={inputClass}
              disabled={!isEditing}
              placeholder="Enter your course"
            />
          </div>
          <div className="space-y-1.5">
            <label className="text-sm font-semibold text-gray-700">Study Year <span className="text-blue-600">*</span></label>
            <input
              name="studentStudyYear"
              value={universityInfo.studentStudyYear}
              onChange={(e) => handleChange(e, setUniversityInfo)}
              className={inputClass}
              disabled={!isEditing}
              placeholder="e.g., 1st Year, 2nd Year"
            />
          </div>
          <div className="space-y-1.5">
            <label className="text-sm font-semibold text-gray-700">Residence Name</label>
            <input
              name="residenceName"
              value={universityInfo.residenceName}
              className={inputClass}
              disabled
            />
          </div>
          <div className="space-y-1.5">
            <label className="text-sm font-semibold text-gray-700">Payment Method</label>
            <input
              name="paymentMethod"
              value={universityInfo.paymentMethod}
              className={inputClass}
              disabled
            />
          </div>
        </div>
      );
    }
    if (currentStep === 2) {
      return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <div className="space-y-1.5">
            <label className="text-sm font-semibold text-gray-700">First Name <span className="text-blue-600">*</span></label>
            <input
              name="kinFirstName"
              value={nextOfKin.kinFirstName}
              onChange={(e) => handleChange(e, setNextOfKin)}
              className={inputClass}
              disabled={!isEditing}
              placeholder="Enter first name"
            />
          </div>
          <div className="space-y-1.5">
            <label className="text-sm font-semibold text-gray-700">Last Name <span className="text-blue-600">*</span></label>
            <input
              name="kinLastName"
              value={nextOfKin.kinLastName}
              onChange={(e) => handleChange(e, setNextOfKin)}
              className={inputClass}
              disabled={!isEditing}
              placeholder="Enter last name"
            />
          </div>
          <div className="space-y-1.5">
            <label className="text-sm font-semibold text-gray-700">Relationship</label>
            <input
              name="kinRelationShip"
              value={nextOfKin.kinRelationShip}
              onChange={(e) => handleChange(e, setNextOfKin)}
              className={inputClass}
              disabled={!isEditing}
              placeholder="e.g., Parent, Guardian"
            />
          </div>
          <div className="space-y-1.5">
            <label className="text-sm font-semibold text-gray-700">Phone Number <span className="text-blue-600">*</span></label>
            <input
              name="kinPhone"
              value={nextOfKin.kinPhone}
              onChange={(e) => handleChange(e, setNextOfKin)}
              className={inputClass}
              disabled={!isEditing}
              placeholder="Enter phone number"
            />
          </div>
          <div className="space-y-1.5">
            <label className="text-sm font-semibold text-gray-700">Email</label>
            <input
              name="kinEmail"
              type="email"
              value={nextOfKin.kinEmail}
              onChange={(e) => handleChange(e, setNextOfKin)}
              className={inputClass}
              disabled={!isEditing}
              placeholder="Enter email address"
            />
          </div>
          <div className="space-y-1.5">
            <label className="text-sm font-semibold text-gray-700">ID Number</label>
            <input
              name="kinIdNumber"
              value={nextOfKin.kinIdNumber}
              onChange={(e) => handleChange(e, setNextOfKin)}
              className={inputClass}
              disabled={!isEditing}
              placeholder="Enter ID number"
            />
          </div>
          <div className="space-y-1.5 md:col-span-2">
            <label className="text-sm font-semibold text-gray-700">Address</label>
            <textarea
              name="kinAddress"
              value={nextOfKin.kinAddress}
              onChange={(e) => handleChange(e, setNextOfKin)}
              className={inputClass}
              rows={2}
              disabled={!isEditing}
              placeholder="Enter address"
            />
          </div>
        </div>
      );
    }
  };

  const navItems = [
    { key: "overview", label: "Overview", icon: <LayoutDashboard className="w-5 h-5" /> },
    { key: "profile", label: "Profile", icon: <User className="w-5 h-5" /> },
    { key: "documents", label: "Documents", icon: <FileText className="w-5 h-5" /> },
    { key: "lease", label: "Lease", icon: <FileSignature className="w-5 h-5" /> },
    { key: "maintenance", label: "Maintenance", icon: <Wrench className="w-5 h-5" /> },
    { key: "invoice", label: "Payments", icon: <CreditCard className="w-5 h-5" /> },
    { key: "residence", label: "Residence", icon: <Home className="w-5 h-5" /> },
  ];

  const getNotificationIcon = (type) => {
    switch (type) {
      case "success":
        return <CheckCircle className="w-4 h-4 text-green-500" />;
      case "error":
        return <AlertCircle className="w-4 h-4 text-red-500" />;
      default:
        return <Bell className="w-4 h-4 text-blue-500" />;
    }
  };

  const unreadCount = notifications.filter(n => n.isAnnouncement && !n.isRead).length;
  const [isSaving, setIsSaving] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Missing Documents Modal */}
      {showMissingDocsModal && (
        <MissingDocumentsModal
          missingDocs={missingDocs}
          onGoToDocs={() => {
            setShowMissingDocsModal(false);
            setActiveTab("documents");
          }}
          onDismiss={() => {
            const studentId = sessionStorage.getItem("StudentUserId");
            if (studentId) {
              sessionStorage.setItem(`dismissedMissingDocs_${studentId}`, "true");
            }
            setShowMissingDocsModal(false);
          }}
        />
      )}

           {/* Sidebar */}
      <aside className="fixed left-0 top-0 h-full w-72 bg-slate-900 shadow-xl z-30 hidden lg:block">
        <div className="flex flex-col h-full">
          {/* Logo */}
          <div className="px-6 py-8 border-b border-white/10">
            <div className="flex items-center gap-3">
              <div className="w-11 h-11 rounded-full overflow-hidden ring-2 ring-white/15 shadow-lg shadow-indigo-900/40 flex-shrink-0 bg-white p-1.5">
                <img
                  src="/LOGOSTAY.png"
                  alt="MSA Logo"
                  className="w-full h-full object-contain"
                />
              </div>
              <div>
                <h1 className="text-xl font-bold text-white">
                  MSA Portal
                </h1>
                <p className="text-xs text-slate-400">Student Dashboard</p>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <nav className="flex-1 px-4 py-6 space-y-1">
            {navItems.map(({ key, label, icon }) => (
              <button
                key={key}
                onClick={() => setActiveTab(key)}
                className={`
                  w-full flex items-center gap-3 px-4 py-3 rounded-xl
                  transition-all duration-200 group
                  ${activeTab === key
                    ? "bg-gradient-to-r from-blue-600 to-indigo-600 text-white shadow-lg shadow-indigo-900/30"
                    : "text-slate-400 hover:bg-white/5 hover:text-white"
                  }
                `}
              >
                <span className={activeTab === key ? "text-white" : "text-slate-500 group-hover:text-white"}>
                  {icon}
                </span>
                <span className="text-sm font-medium">{label}</span>
                {activeTab === key && (
                  <div className="ml-auto w-1.5 h-1.5 rounded-full bg-white" />
                )}
              </button>
            ))}
          </nav>

          {/* User & Logout */}
          <div className="p-4 border-t border-white/10 mt-auto">
            <div className="flex items-center gap-3 mb-4">
              {profilePicture ? (
                <img
                  src={profilePicture}
                  alt="Profile"
                  className="w-10 h-10 rounded-xl object-cover border border-white/10"
                />
              ) : (
                <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-500 via-indigo-500 to-violet-600 flex items-center justify-center">
                  <User className="w-5 h-5 text-white" />
                </div>
              )}
              <div className="flex-1 text-left">
                <p className="text-sm font-semibold text-white">
                  {personalInfo.firstName || "Student"}
                </p>
                <p className="text-xs text-slate-400 truncate">
                  {personalInfo.email || "student@msa.edu"}
                </p>
              </div>
            </div>
            <button
              onClick={handleLogout}
              className="w-full flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl border border-white/10 text-slate-300 hover:bg-red-600 hover:text-white hover:border-red-600 transition-all duration-200"
            >
              <LogOut className="w-4 h-4" />
              <span className="text-sm font-medium">Sign out</span>
            </button>
          </div>
        </div>
      </aside>

      {/* Mobile Header */}
      <div className="lg:hidden fixed top-0 left-0 right-0 bg-slate-900 shadow-lg z-40 px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-9 h-9 rounded-full overflow-hidden ring-2 ring-white/15 flex-shrink-0 bg-white p-1">
            <img
              src="/LOGOSTAY.png"
              alt="MSA Logo"
              className="w-full h-full object-contain"
            />
          </div>
          <span className="font-semibold text-white">MSA Portal</span>
        </div>
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="p-2 rounded-lg hover:bg-white/5 transition"
        >
          <Menu className="w-5 h-5 text-white" />
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <>
          <div className="lg:hidden fixed inset-0 bg-black/50 z-40" onClick={() => setMobileMenuOpen(false)} />
          <div className="lg:hidden fixed top-0 left-0 bottom-0 w-72 bg-slate-900 z-50 shadow-xl">
            <div className="px-5 py-6 border-b border-white/10 flex justify-between items-center">
              <div className="flex items-center gap-2">
                <div className="w-9 h-9 rounded-full overflow-hidden ring-2 ring-white/15 flex-shrink-0 bg-white p-1">
                  <img
                    src="/LOGOSTAY.png"
                    alt="MSA Logo"
                    className="w-full h-full object-contain"
                  />
                </div>
                <span className="font-semibold text-white">MSA Portal</span>
              </div>
              <button onClick={() => setMobileMenuOpen(false)} className="p-1 rounded-lg hover:bg-white/5">
                <X className="w-5 h-5 text-slate-400" />
              </button>
            </div>
            <nav className="px-4 py-4">
              {navItems.map(({ key, label, icon }) => (
                <button
                  key={key}
                  onClick={() => {
                    setActiveTab(key);
                    setMobileMenuOpen(false);
                  }}
                  className={`
                    w-full flex items-center gap-3 px-4 py-3 rounded-xl mb-1
                    transition-all duration-200
                    ${activeTab === key ? "bg-gradient-to-r from-blue-600 to-indigo-600 text-white shadow-lg shadow-indigo-900/30" : "text-slate-400 hover:bg-white/5 hover:text-white"}
                  `}
                >
                  {icon}
                  <span className="text-sm font-medium">{label}</span>
                </button>
              ))}
            </nav>
            <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-white/10">
              <button
                onClick={handleLogout}
                className="w-full flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl border border-white/10 text-slate-300 hover:bg-red-600 hover:text-white hover:border-red-600 transition-all duration-200"
              >
                <LogOut className="w-4 h-4" />
                <span className="text-sm font-medium">Sign out</span>
              </button>
            </div>
          </div>
        </>
      )}


      {/* Main Content */}
      <main className="lg:ml-72">
        <div className="p-5 md:p-8 pt-20 lg:pt-8">
          {/* Overview Tab */}
         {/* Overview Tab */}
{activeTab === "overview" && (
  <div className="max-w-7xl mx-auto space-y-6">
    {/* Welcome Banner */}
    <div className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-blue-700 via-blue-800 to-slate-900 p-6 md:p-8 text-white shadow-md">
      <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -mr-32 -mt-32" />
      <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/5 rounded-full -ml-24 -mb-24" />
      <div className="relative z-10 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <h1 className="text-2xl md:text-3xl font-bold mb-2">
            Welcome back, {personalInfo.firstName || "Student"}
          </h1>
          <p className="text-blue-100 max-w-lg text-sm md:text-base">
            Here's a quick look at your residence, documents, and academic details. Use the quick actions below to stay on top of what's due.
          </p>
        </div>
        <div className="flex flex-col gap-1 bg-white/10 backdrop-blur-sm rounded-xl px-4 py-3 border border-white/15 min-w-[160px]">
          <p className="text-xs text-blue-100">Academic year</p>
          <p className="text-sm font-semibold text-white">2024 / 2025</p>
          <div className="h-px bg-white/15 my-1.5" />
          <p className="text-xs text-blue-100">Student number</p>
          <p className="text-sm font-semibold text-white">{personalInfo.studentNumber || "Not set"}</p>
        </div>
      </div>
    </div>

    {/* Stats Grid */}
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
      <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-200 border-l-4 border-l-blue-600 hover:shadow-md transition-all duration-200">
        <div className="flex items-center justify-between mb-3">
          <div className="p-2.5 bg-blue-50 rounded-lg">
            <BedDouble className="w-5 h-5 text-blue-700" />
          </div>
          <span className={`text-xs font-medium px-2 py-1 rounded-full ${
            roomInfo.roomNumber ? "text-green-700 bg-green-50" : "text-amber-700 bg-amber-50"
          }`}>
            {roomInfo.roomNumber ? "Assigned" : "Pending"}
          </span>
        </div>
        <p className="text-sm text-gray-500">Room assignment</p>
        {roomInfo.roomNumber ? (
          <>
            <p className="text-2xl font-bold text-gray-900 mt-1">Room {roomInfo.roomNumber}</p>
            <p className="text-xs text-gray-400 mt-2">{roomInfo.block} &middot; Floor {roomInfo.floor}</p>
          </>
        ) : (
          <>
            <p className="text-2xl font-bold text-gray-900 mt-1">&mdash;</p>
            <p className="text-xs text-gray-400 mt-2">No room allocated yet</p>
          </>
        )}
      </div>

      <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-200 border-l-4 border-l-sky-600 hover:shadow-md transition-all duration-200">
        <div className="flex items-center justify-between mb-3">
          <div className="p-2.5 bg-sky-50 rounded-lg">
            <FileText className="w-5 h-5 text-sky-700" />
          </div>
        </div>
        <p className="text-sm text-gray-500">Documents</p>
        <p className="text-2xl font-bold text-gray-900 mt-1">{uploadedCount}</p>
        <p className="text-xs text-gray-400 mt-2">Documents uploaded so far</p>
      </div>

      <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-200 border-l-4 border-l-indigo-600 hover:shadow-md transition-all duration-200">
        <div className="flex items-center justify-between mb-3">
          <div className="p-2.5 bg-indigo-50 rounded-lg">
            <GraduationCap className="w-5 h-5 text-indigo-700" />
          </div>
        </div>
        <p className="text-sm text-gray-500">Current course</p>
        <p className="text-base font-semibold text-gray-900 mt-1 truncate">
          {universityInfo.studentCourse || "Not enrolled"}
        </p>
        <p className="text-xs text-gray-400 mt-2">Year {universityInfo.studentStudyYear || "N/A"} of study</p>
      </div>

      <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-200 border-l-4 border-l-slate-600 hover:shadow-md transition-all duration-200">
        <div className="flex items-center justify-between mb-3">
          <div className="p-2.5 bg-slate-100 rounded-lg">
            <Award className="w-5 h-5 text-slate-700" />
          </div>
          <span className="text-xs font-medium text-green-700 bg-green-50 px-2 py-1 rounded-full">Active</span>
        </div>
        <p className="text-sm text-gray-500">Residence status</p>
        <p className="text-base font-semibold text-gray-900 mt-1">
          {universityInfo.residenceName || "Pending"}
        </p>
        <p className="text-xs text-gray-400 mt-2">Your current student residence</p>
      </div>
    </div>

    {/* Quick Actions */}
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <div className="mb-4">
        <h2 className="text-base font-semibold text-gray-900">Quick actions</h2>
        <p className="text-sm text-gray-500 mt-0.5">Jump straight to the things you're most likely to need</p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <button
          onClick={() => setActiveTab("documents")}
          className="flex items-center justify-center gap-2 px-4 py-3 rounded-xl bg-blue-600 text-white hover:bg-blue-700 transition-all duration-200 text-sm font-semibold shadow-sm"
        >
          <FileText className="w-4 h-4" />
          Upload documents
        </button>
        <button
          onClick={() => setActiveTab("lease")}
          className="flex items-center justify-center gap-2 px-4 py-3 rounded-xl bg-slate-700 text-white hover:bg-slate-800 transition-all duration-200 text-sm font-semibold shadow-sm"
        >
          <FileSignature className="w-4 h-4" />
          View lease
        </button>
        <button
          onClick={() => setActiveTab("invoice")}
          className="flex items-center justify-center gap-2 px-4 py-3 rounded-xl bg-indigo-600 text-white hover:bg-indigo-700 transition-all duration-200 text-sm font-semibold shadow-sm"
        >
          <CreditCard className="w-4 h-4" />
          Make payment
        </button>
        <button
          onClick={() => setActiveTab("profile")}
          className="flex items-center justify-center gap-2 px-4 py-3 rounded-xl bg-gray-700 text-white hover:bg-gray-800 transition-all duration-200 text-sm font-semibold shadow-sm"
        >
          <User className="w-4 h-4" />
          Update profile
        </button>
      </div>
    </div>

    {/* Recent Activity & Info */}
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 flex flex-col h-full">
        <div className="p-5 border-b border-gray-100">
          <div className="flex items-center justify-between">
            <div>
              <div className="flex items-center gap-2">
                <div className="p-1.5 bg-blue-50 rounded-md">
                  <Bell className="w-4 h-4 text-blue-700" />
                </div>
                <h2 className="text-base font-semibold text-gray-900">Recent notifications</h2>
              </div>
              <p className="text-sm text-gray-500 mt-1 ml-1">Updates on documents, announcements, and approvals</p>
            </div>
            <div className="flex items-center gap-3">
              {unreadCount > 0 && (
                <button
                  onClick={markAllAsRead}
                  className="text-xs text-blue-700 hover:text-blue-800 font-medium transition"
                >
                  Mark all as read
                </button>
              )}
              {unreadCount > 0 && (
                <span className="text-xs bg-red-500 text-white px-2 py-1 rounded-full">
                  {unreadCount} new
                </span>
              )}
            </div>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto max-h-[420px]">
          {notifications.length === 0 ? (
            <div className="text-center py-12">
              <Bell className="w-10 h-10 text-gray-300 mx-auto mb-3" />
              <p className="text-gray-500 text-sm">No notifications yet</p>
              <p className="text-xs text-gray-400 mt-1">Check back later for updates</p>
            </div>
          ) : (
            <div className="divide-y divide-gray-100">
              {notifications.map((n) => (
                <div
                  key={n.id}
                  onClick={() => handleNotificationClick(n)}
                  className={`flex items-start gap-3 p-4 transition-all duration-200 cursor-pointer ${
                    n.isAnnouncement
                      ? `hover:bg-blue-50 bg-white border-l-4 ${
                          n.isRead ? 'border-l-gray-300' : 'border-l-blue-600'
                        }`
                      : 'hover:bg-gray-50'
                  }`}
                >
                  <div className="flex-shrink-0">
                    {n.isAnnouncement ? (
                      <div className={`p-2 rounded-lg ${
                        n.isRead ? 'bg-gray-100' : 'bg-blue-50'
                      }`}>
                        <Bell className={`w-4 h-4 ${
                          n.isRead ? 'text-gray-500' : 'text-blue-700'
                        }`} />
                      </div>
                    ) : (
                      getNotificationIcon(n.type)
                    )}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                      <p className={`text-sm ${n.isAnnouncement ? 'font-semibold' : 'text-gray-700'} ${
                        n.isAnnouncement && !n.isRead ? 'text-gray-900' : 'text-gray-600'
                      }`}>
                        {n.message}
                      </p>
                      {n.isAnnouncement && !n.isRead && (
                        <span className="w-2 h-2 bg-blue-600 rounded-full"></span>
                      )}
                    </div>
                    <p className="text-xs text-gray-400 mt-1 flex items-center gap-1">
                      <Calendar className="w-3 h-3" />
                      {n.time}
                    </p>
                  </div>
                  {n.isAnnouncement && (
                    <ChevronRight className={`w-4 h-4 flex-shrink-0 ${
                      n.isRead ? 'text-gray-300' : 'text-gray-400'
                    }`} />
                  )}
                </div>
              ))}
            </div>
          )}
        </div>

        {notifications.length > 0 && (
          <div className="p-3 border-t border-gray-100 bg-slate-50 rounded-b-xl">
            <p className="text-xs text-gray-500 text-center">
              {unreadCount} unread &middot; {notifications.length} total
            </p>
          </div>
        )}
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5">
        <div className="flex items-center gap-2 mb-1">
          <div className="p-1.5 bg-indigo-50 rounded-md">
            <User className="w-4 h-4 text-indigo-700" />
          </div>
          <h2 className="text-base font-semibold text-gray-900">Contact information</h2>
        </div>
        <p className="text-sm text-gray-500 mb-4 ml-1">The details we have on file for you</p>
        <div className="space-y-2">
          <div className="flex items-center justify-between gap-3 p-3 rounded-lg border border-gray-100 hover:bg-slate-50 transition">
            <div className="flex items-center gap-3">
              <Mail className="w-4 h-4 text-blue-600" />
              <span className="text-sm text-gray-700">Email</span>
            </div>
            <span className="text-sm font-medium text-gray-900 truncate max-w-[180px]">{personalInfo.email || "Not set"}</span>
          </div>
          <div className="flex items-center justify-between gap-3 p-3 rounded-lg border border-gray-100 hover:bg-slate-50 transition">
            <div className="flex items-center gap-3">
              <Phone className="w-4 h-4 text-green-600" />
              <span className="text-sm text-gray-700">Phone</span>
            </div>
            <span className="text-sm font-medium text-gray-900">{personalInfo.studentPhoneNumber || "Not set"}</span>
          </div>
          <div className="flex items-center justify-between gap-3 p-3 rounded-lg border border-gray-100 hover:bg-slate-50 transition">
            <div className="flex items-center gap-3">
              <MapPin className="w-4 h-4 text-slate-600" />
              <span className="text-sm text-gray-700">Address</span>
            </div>
            <span className="text-sm font-medium text-gray-900 truncate max-w-[180px]">{personalInfo.studentAddress || "Not set"}</span>
          </div>
          <div className="flex items-center justify-between gap-3 p-3 rounded-lg border border-gray-100 hover:bg-slate-50 transition">
            <div className="flex items-center gap-3">
              <Calendar className="w-4 h-4 text-blue-600" />
              <span className="text-sm text-gray-700">Academic year</span>
            </div>
            <span className="text-sm font-medium text-gray-900">2024 / 2025</span>
          </div>
        </div>
        <button
          onClick={() => setActiveTab("profile")}
          className="w-full mt-4 inline-flex items-center justify-center gap-2 px-3 py-2 text-xs font-medium rounded-md border border-gray-200 bg-white text-gray-700 hover:bg-blue-600 hover:text-white hover:border-blue-600 transition-all duration-200"
        >
          Update contact details
        </button>
      </div>
    </div>
  </div>
)}

{/* Profile Tab */}
{activeTab === "profile" && (
  <div className="max-w-5xl mx-auto space-y-6">
    {/* Profile Header */}
    <div className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-blue-700 via-blue-800 to-slate-900 shadow-md px-6 py-8">
      <div className="absolute top-0 right-0 w-48 h-48 bg-white/5 rounded-full -mr-24 -mt-24" />
      <div className="absolute bottom-0 left-0 w-32 h-32 bg-white/5 rounded-full -ml-16 -mb-16" />
      <div className="relative flex flex-col sm:flex-row items-center gap-6">
        <div className="relative">
          {profilePicture ? (
            <img
              src={profilePicture}
              alt="Profile"
              onClick={() => setIsProfileModalOpen(true)}
              className="w-24 h-24 rounded-2xl object-cover border-4 border-white/20 cursor-pointer hover:scale-105 transition"
            />
          ) : (
            <div
              onClick={() => setIsProfileModalOpen(true)}
              className="w-24 h-24 rounded-2xl bg-white/10 flex items-center justify-center cursor-pointer hover:bg-white/20 transition border-4 border-white/20"
            >
              <User className="w-10 h-10 text-white" />
            </div>
          )}
          <label className="absolute -bottom-1 -right-1 bg-white rounded-full p-1.5 shadow-md cursor-pointer hover:bg-gray-100 transition">
            <Camera className="w-3.5 h-3.5 text-gray-700" />
            <input type="file" accept="image/*" onChange={handleProfilePictureChange} className="hidden" />
          </label>
        </div>
        <div className="text-center sm:text-left flex-1">
          <h1 className="text-2xl font-bold text-white">
            {personalInfo.firstName} {personalInfo.lastName}
          </h1>
          <p className="text-blue-100 text-sm mt-0.5">{universityInfo.studentCourse || "Course not set"}</p>
          <div className="flex flex-wrap items-center justify-center sm:justify-start gap-2 mt-2">
            <span className="inline-flex items-center gap-1.5 text-xs px-2.5 py-1 rounded-full bg-white/10 text-blue-100 border border-white/15">
              Student ID: {personalInfo.studentNumber || "Not set"}
            </span>
            <span className="inline-flex items-center gap-1.5 text-xs px-2.5 py-1 rounded-full bg-white/10 text-blue-100 border border-white/15">
              {universityInfo.residenceName || "No residence"}
            </span>
          </div>
        </div>
        <div className="sm:ml-auto">
          {!isEditing ? (
            <button
              onClick={() => setIsEditing(true)}
              className="px-5 py-2.5 bg-white/10 border border-white/15 backdrop-blur rounded-xl text-white text-sm font-semibold hover:bg-white/20 transition"
            >
              Edit profile
            </button>
          ) : (
            <button
              onClick={handleSaveStep}
              disabled={isSaving}
              className="px-5 py-2.5 bg-blue-600 rounded-xl text-white text-sm font-semibold hover:bg-blue-500 transition shadow-sm disabled:opacity-60"
            >
              {isSaving ? "Saving..." : "Save changes"}
            </button>
          )}
        </div>
      </div>
    </div>

    {/* Form Card */}
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <div className="mb-5">
        <h2 className="text-base font-semibold text-gray-900">Profile details</h2>
        <p className="text-sm text-gray-500 mt-0.5">
          {isEditing
            ? "Make your changes below, then save to update your profile."
            : "Review your personal, academic, and emergency contact information."}
        </p>
      </div>

      {/* Step Indicator */}
      <div className="flex items-center gap-3 mb-6">
        {["Personal info", "Academic info", "Emergency contact"].map((label, idx) => (
          <div key={idx} className="flex items-center flex-1">
            <button
              onClick={() => setCurrentStep(idx)}
              className="flex items-center gap-2 w-full"
            >
              <div
                className={`
                  w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold transition-all duration-200
                  ${currentStep === idx
                    ? "bg-blue-600 text-white"
                    : currentStep > idx
                      ? "bg-green-100 text-green-700 border border-green-200"
                      : "bg-gray-100 text-gray-400 border border-gray-200"
                  }
                `}
              >
                {currentStep > idx ? <CheckCircle className="w-4 h-4" /> : idx + 1}
              </div>
              <span className={`text-sm font-medium hidden sm:inline ${currentStep === idx ? "text-gray-900" : "text-gray-400"}`}>
                {label}
              </span>
            </button>
            {idx < 2 && (
              <div className={`flex-1 h-0.5 mx-3 rounded transition-colors duration-200 ${currentStep > idx ? "bg-green-300" : "bg-gray-200"}`} />
            )}
          </div>
        ))}
      </div>

      {renderProfileForm()}

      {/* Navigation Buttons */}
      <div className="flex justify-between mt-8 pt-5 border-t border-gray-100">
        <button
          onClick={prevStep}
          className={`px-4 py-2 text-sm font-medium rounded-lg border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 transition ${currentStep === 0 ? "invisible" : ""}`}
        >
          <ChevronLeft className="w-4 h-4 inline mr-1" />
          Previous
        </button>
        {currentStep < 2 && (
          <button
            onClick={nextStep}
            className="px-4 py-2 text-sm font-medium rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition shadow-sm"
          >
            Next
            <ChevronRight className="w-4 h-4 inline ml-1" />
          </button>
        )}
      </div>
    </div>
  </div>
)}


          {/* Other Tabs */}
          {activeTab === "documents" && <Documents />}
          {activeTab === "lease" && (
            <LeaseAgreement
              studentId={sessionStorage.getItem("StudentUserId")}
              showFinalizeButton={false}
            />
          )}

          {activeTab === "maintenance" &&( <Maintenance studentId={sessionStorage.getItem("StudentUserId")} />)}

          {activeTab === "residence" && (
            residenceId ? (
              <ResidenceInfomation residenceId={residenceId} />
            ) : (
              <div className="flex items-center justify-center p-12 bg-white rounded-2xl shadow-md">
                <div className="text-center">
                  <Home className="w-12 h-12 text-gray-300 mx-auto mb-3" />
                  <p className="text-gray-500">Loading residence information...</p>
                </div>
              </div>
            )
          )}
          {activeTab === "invoice" && (
            <Invoice studentId={sessionStorage.getItem("StudentUserId")} />
          )}
        </div>
      </main>

      {/* Profile Picture Modal */}
      {isProfileModalOpen && (
        <div
          className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4"
          onClick={() => setIsProfileModalOpen(false)}
        >
          <div onClick={(e) => e.stopPropagation()} className="bg-white rounded-2xl max-w-md w-full p-6 shadow-2xl">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-2">
                <Camera className="w-5 h-5 text-gray-600" />
                <h3 className="text-lg font-bold text-gray-900">Profile Picture</h3>
              </div>
              <button onClick={() => setIsProfileModalOpen(false)} className="p-1 rounded-lg hover:bg-gray-100">
                <X className="w-5 h-5 text-gray-500" />
              </button>
            </div>
            <div className="flex justify-center bg-gray-100 rounded-xl p-4">
              <img
                src={profilePicture || "/api/placeholder/400/400"}
                alt="Profile Preview"
                className="max-h-96 rounded-lg object-contain"
              />
            </div>
            <button
              onClick={() => setIsProfileModalOpen(false)}
              className="mt-6 w-full py-2.5 rounded-xl bg-gray-800 text-white hover:bg-gray-900 transition font-semibold"
            >
              Close
            </button>
          </div>
        </div>
      )}

      {/* Toast */}
      {toast.message && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast({ message: "", type: "" })}
        />
      )}

      {/* MSA Assistant - Integrated Chatbot */}
      <MSAAssistant 
        studentId={sessionStorage.getItem("StudentUserId")}
        personalInfo={personalInfo}
        universityInfo={universityInfo}
        roomInfo={roomInfo}
        uploadedCount={uploadedCount}
        residenceId={residenceId}
      />

      {/* Announcement Detail Modal */}
      {showAnnouncementModal && selectedAnnouncement && (
        <div
          className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4"
          onClick={() => setShowAnnouncementModal(false)}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-2xl max-w-2xl w-full max-h-[85vh] overflow-hidden shadow-2xl animate-in fade-in zoom-in duration-200"
          >
            {/* Modal Header */}
            <div className="bg-gradient-to-r from-blue-600 via-blue-700 to-gray-800 px-6 py-4 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="p-1.5 bg-white/20 rounded-xl">
                  <Bell className="w-5 h-5 text-white" />
                </div>
                <h3 className="text-lg font-bold text-white">Announcement</h3>
              </div>
              <button
                onClick={() => setShowAnnouncementModal(false)}
                className="p-1.5 rounded-lg hover:bg-white/20 transition text-white"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            {/* Modal Body */}
            <div className="p-6 overflow-y-auto max-h-[calc(85vh-120px)] bg-gray-50">
              <div className="bg-white rounded-xl p-6 shadow-sm">
                {/* Title Section */}
                <div className="mb-4">
                  <div className="flex items-start justify-between mb-3">
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-2">
                        <div className="p-1.5 bg-blue-100 rounded-lg">
                          <FileText className="w-4 h-4 text-blue-600" />
                        </div>
                        <h2 className="text-xl font-bold text-gray-900">
                          {selectedAnnouncement.title}
                        </h2>
                      </div>
                    </div>
                    <div className="flex items-center gap-1.5 bg-gray-100 px-2.5 py-1.5 rounded-full">
                      <Calendar className="w-3.5 h-3.5 text-gray-500" />
                      <span className="text-xs text-gray-600">
                        {new Date(selectedAnnouncement.createdAt).toLocaleDateString()}
                      </span>
                    </div>
                  </div>

                  {/* Audience Badge */}
                  <div className="mb-4">
                    <span className={`inline-flex items-center gap-1.5 text-xs px-2.5 py-1.5 rounded-full font-medium ${selectedAnnouncement.audience === 'all'
                        ? 'bg-green-100 text-green-700'
                        : selectedAnnouncement.audience === 'male'
                          ? 'bg-blue-100 text-blue-700'
                          : 'bg-pink-100 text-pink-700'
                      }`}>
                      {selectedAnnouncement.audience === 'all' ? (
                        <Users className="w-3.5 h-3.5" />
                      ) : (
                        <User className="w-3.5 h-3.5" />
                      )}
                      {selectedAnnouncement.audience === 'all'
                        ? 'For Everyone'
                        : selectedAnnouncement.audience === 'male'
                          ? 'For Male Students'
                          : 'For Female Students'}
                    </span>
                  </div>

                  {/* Divider */}
                  <div className="h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent my-4" />

                  {/* Content */}
                  <div className="prose max-w-none">
                    <p className="text-gray-700 whitespace-pre-wrap leading-relaxed text-base">
                      {selectedAnnouncement.content}
                    </p>
                  </div>

                  {/* Attachments */}
                  {selectedAnnouncement.attachments && selectedAnnouncement.attachments.length > 0 && (
                    <div className="mt-6 pt-4 border-t border-gray-200">
                      <div className="flex items-center gap-2 mb-3">
                        <div className="p-1.5 bg-blue-100 rounded-lg">
                          <FileSignature className="w-4 h-4 text-blue-600" />
                        </div>
                        <h4 className="text-sm font-semibold text-gray-700">Attachments</h4>
                        <span className="text-xs text-gray-500">
                          ({selectedAnnouncement.attachments.length})
                        </span>
                      </div>
                      <div className="space-y-2">
                        {selectedAnnouncement.attachments.map((attachment) => (
                          <a
                            key={attachment.id}
                            href={`https://msarestapis-acckcpbyeshpa3f3.southafricanorth-01.azurewebsites.net/${attachment.filePath}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center justify-between p-3 rounded-xl bg-gray-50 hover:bg-blue-50 transition-all duration-200 group border border-gray-100 hover:border-blue-200"
                          >
                            <div className="flex items-center gap-3">
                              <div className="p-1.5 bg-white rounded-lg shadow-sm">
                                <FileText className="w-4 h-4 text-blue-500" />
                              </div>
                              <div className="flex flex-col">
                                <span className="text-sm font-medium text-gray-700 group-hover:text-blue-600 transition">
                                  {attachment.fileName}
                                </span>
                                <span className="text-xs text-gray-400">Click to download</span>
                              </div>
                            </div>
                            <div className="p-1.5 bg-white rounded-lg opacity-0 group-hover:opacity-100 transition">
                              <FileSignature className="w-3.5 h-3.5 text-blue-500" />
                            </div>
                          </a>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Modal Footer */}
            <div className="px-6 py-4 bg-white border-t border-gray-200 flex justify-end gap-3">
              <button
                onClick={() => setShowAnnouncementModal(false)}
                className="flex items-center gap-2 px-5 py-2.5 bg-gray-100 text-gray-700 rounded-xl hover:bg-gray-200 transition font-medium"
              >
                <X className="w-4 h-4" />
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;